import { ThemeDefaults } from '@bbkFunnel/pages/theme';

export type ThemeLabelLocale = 'en' | 'es';

export type ThemeLabelDefaults = Pick<
  typeof ThemeDefaults,
  | 'FORM_REQUIRED_LABEL'
  | 'FORM_REQUIRED_FIELD_ERROR'
  | 'SURVEY_ERROR_BOX_TITLE'
  | 'SURVEY_ERROR_BOX_CONTENT'
>;

const EN_LABEL_DEFAULTS: ThemeLabelDefaults = {
  FORM_REQUIRED_LABEL: ThemeDefaults.FORM_REQUIRED_LABEL,
  FORM_REQUIRED_FIELD_ERROR: ThemeDefaults.FORM_REQUIRED_FIELD_ERROR,
  SURVEY_ERROR_BOX_TITLE: ThemeDefaults.SURVEY_ERROR_BOX_TITLE,
  SURVEY_ERROR_BOX_CONTENT: ThemeDefaults.SURVEY_ERROR_BOX_CONTENT,
};

const ES_LABEL_DEFAULTS: ThemeLabelDefaults = {
  FORM_REQUIRED_LABEL: 'OBLIGATORIO',
  FORM_REQUIRED_FIELD_ERROR: 'Esta pregunta es obligatoria.',
  SURVEY_ERROR_BOX_TITLE: 'Se produjo un error.',
  SURVEY_ERROR_BOX_CONTENT: 'Complete todos los campos obligatorios.',
};

const LABEL_DEFAULTS_BY_LOCALE: Record<ThemeLabelLocale, ThemeLabelDefaults> = {
  en: EN_LABEL_DEFAULTS,
  es: ES_LABEL_DEFAULTS,
};

export const resolveThemeLabelLocale = (
  locale?: string | null
): ThemeLabelLocale => {
  if (!locale?.trim()) {
    return 'en';
  }

  const normalized = locale.trim().toLowerCase().replace(/_/g, '-');
  if (normalized === 'es' || normalized.startsWith('es-')) {
    return 'es';
  }

  return 'en';
};

export const getThemeLabelDefaults = (
  locale?: string | null
): ThemeLabelDefaults =>
  LABEL_DEFAULTS_BY_LOCALE[resolveThemeLabelLocale(locale)];
